import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5b22f6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "op-icon" }, null, -1))
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "op-icon fh-c-c" }
const _hoisted_5 = { class: "op-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_EllipsisOutlined = _resolveComponent("EllipsisOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["level-name fh-c-b", { 'active': _ctx.data.active, 'selected': _ctx.data.id == _ctx.selectedId, 'disabled': _ctx.data.status === 0}])
  }, [
    (_ctx.data.children && _ctx.data.children.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "triangle",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.data.active = !_ctx.data.active), ["stop"]))
        }))
      : _createCommentVNode("", true),
    (_ctx.data.id === -1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_a_input, {
            ref: "iptRef",
            value: _ctx.data.name,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.name) = $event)),
            onBlur: _ctx.handleBlur,
            onKeyup: _withKeys(_ctx.handleEnter, ["enter"]),
            maxlength: 32
          }, null, 8, ["value", "onBlur", "onKeyup"]),
          _hoisted_1
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", {
            class: "name f1",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleSelect(_ctx.data)), ["stop"])),
            title: _ctx.data.name === 'DEFAULT_SERVICE_DESK_NAME' ? '默认服务台' : _ctx.data.name
          }, [
            _createTextVNode(_toDisplayString(_ctx.data.name === 'DEFAULT_SERVICE_DESK_NAME' ? '默认服务台' : _ctx.data.name), 1),
            (!_ctx.data.isRoot)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "（" + _toDisplayString(_ctx.data.engineerCount) + "）", 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2),
          (_ctx.showOperation)
            ? (_openBlock(), _createBlock(_component_a_popover, {
                key: 0,
                placement: "bottom"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.hasPermission('service_desk_create'))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "op-item",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleAdd && _ctx.handleAdd(...args)))
                        }, "添加子部门"))
                      : _createCommentVNode("", true),
                    (!_ctx.data.isRoot && _ctx.hasPermission('service_desk_update'))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "op-item",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleEdit && _ctx.handleEdit(...args)))
                        }, "编辑"))
                      : _createCommentVNode("", true),
                    (!_ctx.data.isRoot && _ctx.hasPermission('service_desk_delete') && !_ctx.data.isDefault)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "op-item",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDelete && _ctx.handleDelete(...args)))
                        }, "删除"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_EllipsisOutlined, {
                      rotate: 90,
                      style: _normalizeStyle({ 'color': 'var(--sys-main-color)' })
                    }, null, 8, ["style"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
}